
<v-chip
    :color = "validEmails ? color : 'error'"
    style  = "width: 240px;"
    @click:close = "onRemove"
    close
>
    <div>
        <p-recipient-chip-menu
            v-if="recipient.emails.length > 1"
            :email-list = "recipient.emails"
        />
    </div>
    <div class="pl-1" :style="'width:' + width">
        <div>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <div
                        v-bind="attrs"
                        v-on="on"
                        class="recipient-chip"
                    >
                        {{ recipient.name }} {{ recipient.company ? recipient.company.name : '' }}
                    </div>
                </template>

                <div >
                    {{ recipient.name }} {{ recipient.company ? recipient.company.name : '' }}
                </div>
            </v-tooltip>


        </div>
        <div class="recipient-mail">
            {{ recipient.email }}
        </div>
    </div>
</v-chip>
